var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.013 45.973c-6.32 0-16.1-7.187-26.4-6.933-13.6.18-26.066 7.886-33.073 20.093-14.113 24.5-3.64 60.686 10.127 80.6 6.753 9.693 14.72 20.6 25.28 20.26 10.133-.433 13.933-6.58 26.233-6.58 12.207 0 15.667 6.58 26.4 6.32 10.913-.174 17.84-9.867 24.507-19.653a87.003 87.003 0 0 0 11.08-22.767c-.26-.087-21.214-8.14-21.467-32.38-.173-20.267 16.533-29.96 17.313-30.393-9.527-13.934-24.153-15.494-29.267-15.84-13.333-1.04-24.5 7.267-30.733 7.267Zm22.52-20.44c5.62-6.747 9.334-16.18 8.3-25.533-8.046.346-17.746 5.366-23.546 12.12-5.2 5.973-9.693 15.586-8.487 24.76 8.92.693 18.1-4.587 23.727-11.34"
})));

export default SvgApple;